import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    cardId: string; // widget instance id
    includeSuggestions?: boolean;
    applyPersonalization?: boolean;
    includeAttributes?: string[];
    relevancy?: boolean;
    includeProductsInSubCategories?: boolean;
    categoryId?: string;
    brandIds?: string[];
    expand?: string[];
    page?: number;
    pageSize?: number;
    onSuccess?: (products: ProductModel[]) => void;
    onError?: (errorMessage: string) => void;
    isShellEdit?: boolean;
}

type Props = {
    getProductCollectionParameter?: GetProductCollectionApiV2Parameter;
};

type HandlerType = Handler<Parameter, Props>;

export const PrepareApiParameter: HandlerType = props => {
    const {
        includeSuggestions,
        applyPersonalization,
        includeAttributes,
        relevancy,
        includeProductsInSubCategories,
        categoryId,
        brandIds,
        expand,
        page,
        pageSize,
    } = props.parameter;

    props.getProductCollectionParameter = {
        includeSuggestions,
        applyPersonalization,
        includeAttributes,
        relevancy,
        includeProductsInSubCategories,
        categoryId,
        brandIds,
        expand,
        page,
        pageSize,
    } as GetProductCollectionApiV2Parameter;
};

export const LoadProducts: HandlerType = ({ dispatch, getProductCollectionParameter, parameter }) => {
    if (!getProductCollectionParameter) {
        return;
    }

    getProductCollectionParameter.expand = [...(getProductCollectionParameter.expand || []), "images", "badges"];

    dispatch(
        loadProductInfoList({
            id: parameter.cardId,
            getProductCollectionParameter,
            isShellEdit: parameter.isShellEdit,
            forceLoad: false,
        }),
    );
};

export const chain = [PrepareApiParameter, LoadProducts];

const loadBrandCategoryProducts = createHandlerChainRunner(chain, "LoadBrandCategoryProducts");
export default loadBrandCategoryProducts;
